import { HISTORY_ID } from 'constants/api'
import axios from 'axios'
import dayjs from 'dayjs'

export const fetchHistoryId = async (id: string, token: string) => {
  try {
    const response = await axios.get(HISTORY_ID.replace(':id', id), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Ph-Api-Id': PH_API_ID ?? 1
      }
    })
    return response.data
  } catch (error) {
    console.error('Error al obtener HISTORY_ID:', error)
    return null
  }
}

export const timeResult = (date: any) => {
  const currentDate = dayjs(new Date())

  const compareDate = new Date(date as string)

  const diff = dayjs(compareDate)

  const result = currentDate <= diff

  if (result) {
    return true
  }

  return false
}
